import { render, staticRenderFns } from "./ocr.vue?vue&type=template&id=22cf819c&scoped=true&"
import script from "./ocr.vue?vue&type=script&lang=js&"
export * from "./ocr.vue?vue&type=script&lang=js&"
import style1 from "./ocr.vue?vue&type=style&index=1&id=22cf819c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf819c",
  null
  
)

export default component.exports